<template>
  <div class="pedido-concluido">
    <div class="container custom-container">
      <div class="row">
        <div class="col-24">
          <HeliarNav />
          <div class="pedido-concluido--box">
            <span class="box--icon icon icon-success"></span>
            <p class="box--title">Seu pedido foi concluído!</p>
            <div class="box--text-wrapper"></div>
            <p class="box--text">
              Enviamos os detalhes do seu pedido para
              <span class="highlight">{{ this.email }}</span>
            </p>
            <p class="box--text">
              Para mais informações, entre em contato com a revenda responsável
              pela entrega através do telefone disponível no e-mail.
            </p>
          </div>
          <div class="pedido-concluido--banner">
            <a href="https://www.instagram.com/bateriasheliar" target="_blank"
              ><picture class="img-responsive"
                ><source
                  media="(max-width: 991px)"
                  srcset="../assets/banner-pedido-concluido-mobile.jpg"/>
                <img
                  src="../assets/banner-pedido-concluido.jpg"
                  alt="Banner Pedido Concluído"/></picture
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeliarNav from "../components/HeliarNav.vue";

export default {
  components: { HeliarNav },
  data() {
    return {
      email: "",
    };
  },
  created() {
    this.email = this.$route.params.email;
  }
};
</script>
<style lang="scss">
.pedido-concluido {
  padding-top: 56px;
  padding-bottom: 84px;
  color: $cinza-escuro;
  &--box {
    width: 100%;
    background-color: $second-bg-color;
    text-align: center;
    padding: 80px 290px;
    border-radius: 10px;
    box-shadow: 0px 1px 4px 0px #0c0c0d1a, 0px 1px 4px 0px #0c0c0d0d;
    margin-bottom: 82px;
    .box {
      &--icon {
        color: $verde-heliar;
        font-size: 188px;
        display: inline-block;
        margin-bottom: 35px;
        line-height: 0;
      }
      &--title {
        font-weight: 700;
        font-size: 26px;
        margin-bottom: 40px;
        text-transform: uppercase;
      }
      &--text {
        margin-bottom: 0;
        font-size: 16px;
        .highlight {
          color: $verde-heliar;
          font-style: italic;
        }
      }
    }
  }
  &--banner {
    .img-responsive {
      width: 100%;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 0;
      display: block;
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
@media (max-width: 1600px) {
  .pedido-concluido {
    &--box {
      padding: 80px 230px;
    }
  }
}
@media (max-width: 1200px) {
  .pedido-concluido {
    &--box {
      padding: 80px;
    }
  }
}
@media (max-width: 991px) {
  .pedido-concluido {
    padding-top: 105px;
    padding-bottom: 105px;
    &--box {
      margin-bottom: 56px;
      padding: 210px 56px;
      border-radius: 21px;
      .box {
        &--icon {
          margin-bottom: 100px;
          font-size: 192px;
        }
        &--title {
          margin-bottom: 28px;
          font-size: 36px;
          font-style: italic;
        }
        &--text {
          font-size: 28px;
          display: inline;
          line-height: 1;
        }
      }
    }
    &--banner {
      .img-responsive {
        border-radius: 21px;
      }
    }
  }
}
@media (max-width: 767px) {
  .pedido-concluido {
    padding-top: 85px;
    padding-bottom: 85px;
    &--box {
      padding: 175px 50px;
      margin-bottom: 50px;
      .box {
        &--icon {
          font-size: 165px;
          margin-bottom: 75px;
        }
        &--title {
          font-size: 32px;
          margin-bottom: 25px;
        }
        &--text {
          font-size: 24px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .pedido-concluido {
    padding-top: 65px;
    padding-bottom: 65px;
    &--box {
      padding: 100px 15px;
      margin-bottom: 35px;
      .box {
        &--icon {
          font-size: 125px;
          margin-bottom: 50px;
        }
        &--title {
          font-size: 24px;
          margin-bottom: 20px;
        }
        &--text {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
